import * as _ from 'lodash'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom';
import { Button, Card, CardFooter, Form, Input } from 'reactstrap';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { GridContainer } from '../../components/ui/Grid';
import { ExtractPropertiesWithType } from '../../util/types';
import { SurveyManagementHttp } from './lib/http';
import { FileSurveyInstanceTypes, IFileSurvey, IFileSurveyBranchInstance, IFileSurveyInstance, IVerificationBeforeSend } from './lib/interfaces';

interface IRouteProps {
  clientAbbr: string
}

export interface ISurveyProcessContainerProps extends RouteComponentProps<IRouteProps> {
  onSuccess: (res: IVerificationBeforeSend) => void
}

type FileSurveyInstanceProps = ExtractPropertiesWithType<IFileSurvey, FileSurveyInstanceTypes>[0]

interface ISurveyProcessContainerState extends IRouteProps {
  fileSurveys: IFileSurvey[]
  surveysExpanded: string[]
  loading: boolean
  showExtraFields: boolean
  submitting: boolean
}

export class SurveyProcessContainer extends React.Component<ISurveyProcessContainerProps, ISurveyProcessContainerState> {
  state: ISurveyProcessContainerState = {
    fileSurveys: [],
    surveysExpanded: [],
    clientAbbr: '',
    loading: false,
    showExtraFields: false,
    submitting: false,
  }

  cachedFileSurveys: IFileSurvey[] = []

  componentWillMount() {
    this.getSurveys();
  }

  getSurveys() {
    const { clientAbbr = '' } = this.props.match.params

    this.setState({ clientAbbr, fileSurveys: [], loading: true })

    SurveyManagementHttp.getFileProfile(clientAbbr)
      .then((res) => {
        if (res.response) {
          this.initSurveys(res.response)
        }
      })
      .finally(() => this.setState({ loading: false }))
  }


  getPrioritizedSurveys(priority: string) {
    const { clientAbbr = '' } = this.props.match.params

    this.setState({ clientAbbr, fileSurveys: [], loading: true })

    SurveyManagementHttp.getPrioritizedFileProfile(clientAbbr, priority)
      .then((res) => {
        if (res.response) {
          this.initSurveys(res.response)
        }
      })
      .finally(() => this.setState({ loading: false }))
  }


  initSurveys(fileSurveys: IFileSurvey[] = this.cachedFileSurveys) {
    this.cachedFileSurveys = _.cloneDeep(fileSurveys)

    this.setState({ fileSurveys })
  }

  getNumberFieldStyle() {
    const { showExtraFields } = this.state
    const width = showExtraFields ? 125 : 175;
    const style: React.CSSProperties = { width, textAlign: 'right' };

    return style
  }

  toggleShowExtraFields(showExtraFields = !this.state.showExtraFields) {
    this.setState({ showExtraFields })
  }

  toggleSurveyShown(record: IFileSurvey) {
    const { id } = record
    const { surveysExpanded } = this.state
    const indexOfSurvey = surveysExpanded.indexOf(id)

    if (indexOfSurvey >= 0) {
      surveysExpanded.splice(indexOfSurvey, 1)
    } else {
      surveysExpanded.push(id)
    }

    this.setState({ surveysExpanded })
  }

  isSurveyShown(record: IFileSurvey) {
    const { id } = record
    const { surveysExpanded } = this.state
    const indexOfSurvey = surveysExpanded.indexOf(id)

    return indexOfSurvey >= 0;
  }

  renderSurveyTable(fileSurvey: IFileSurvey) {
    const { totals, online, JAC } = fileSurvey

    if (totals instanceof Array && online instanceof Array && JAC instanceof Array) {
      const totalRow: IFileSurveyInstance = {
        availableRecords: _.sumBy(totals, 'availableRecords'),
        completed: _.sumBy(totals, 'completed'),
        quota: _.sumBy(totals, 'quota'),
        threeMonthResponseRate: _.sumBy(totals, 'threeMonthResponseRate'),
        todaysTarget: _.sumBy(totals, 'todaysTarget'),
        requiredToday: _.sumBy(totals, 'requiredToday'),
        sampleToday: _.sumBy(totals, 'sampleToday'),
        undialedSample: _.sumBy(totals, 'undialedSample'),
        undialedSampleAgeInDays: _.sumBy(totals, 'undialedSampleAgeInDays'),
      }

      return (
        <>
          {this.renderSurveyTableRow(fileSurvey, totalRow, 'totals')}
          <tr className="table-primary">
            <td colSpan={10} className="p-2">
              <h6 className="d-flex justify-content-start mb-0">
                <span className="mr-4">Online</span>
              </h6>
            </td>
          </tr>
          {online.map((onlineRow, keyIdx) => this.renderSurveyTableRow(fileSurvey, onlineRow, 'online', keyIdx))}
          <tr className="table-primary">
            <td colSpan={10} className="p-2">
              <h6 className="d-flex justify-content-start mb-0">
                <span className="mr-4">JAC</span>
              </h6>
            </td>
          </tr>
          {JAC.map((jacRow, keyIdx) => this.renderSurveyTableRow(fileSurvey, jacRow, 'JAC', keyIdx))}
        </>
      )
    } else {
      return (
        <>
          {this.renderSurveyTableRow(fileSurvey, fileSurvey.totals, 'totals')}
          {this.renderSurveyTableRow(fileSurvey, fileSurvey.online, 'online')}
          {this.renderSurveyTableRow(fileSurvey, fileSurvey.JAC, 'JAC')}
        </>
      )
    }
  }

  renderSurveyTableRow(fileSurvey: IFileSurvey, fileSurveyInstance: FileSurveyInstanceTypes | IFileSurveyBranchInstance, prop: FileSurveyInstanceProps, keyIdx?: number) {
    const numberFieldStyle = this.getNumberFieldStyle()
    const isTotals = prop === 'totals'
    let title: string = prop;
    const titleStyles: React.CSSProperties = {};

    if (prop === 'online') {
      title = 'Online';
    } else if (prop === 'totals') {
      title = 'Totals';
      titleStyles.fontWeight = 'bold'
    }

    if ('branchName' in fileSurveyInstance) {
      title = fileSurveyInstance.branchName;
    }

    //Never runs
    if (fileSurveyInstance instanceof Array) { //Is Branch Surveys
      return;
    }

    return (
      <tr key={keyIdx}>
        <td style={titleStyles}>{title}</td>
        <td style={numberFieldStyle}>{fileSurveyInstance.availableRecords.toLocaleString()}</td>
        <td style={numberFieldStyle}>{fileSurveyInstance.completed.toLocaleString()}</td>
        <td style={numberFieldStyle}>{fileSurveyInstance.quota.toLocaleString()}</td>
        {this.state.showExtraFields &&
          <>
            <td style={numberFieldStyle}>{fileSurveyInstance.threeMonthResponseRate.toLocaleString()}</td>
            <td style={numberFieldStyle}>{fileSurveyInstance.todaysTarget.toLocaleString()}</td>
            <td style={numberFieldStyle}>{fileSurveyInstance.requiredToday.toLocaleString()}</td>
            <td style={numberFieldStyle}>{fileSurveyInstance.undialedSample}</td>
            <td style={numberFieldStyle}>{fileSurveyInstance.undialedSampleAgeInDays}</td>
          </>
        }
        <td style={numberFieldStyle}>
          {!isTotals &&
            <Input type="number" required
              bsSize="sm"
              className="border-primary"
              min={0}
              max={fileSurveyInstance.availableRecords}
              onChange={(e) => this.updateSampleTodayValue(fileSurvey, fileSurveyInstance, prop, Number(e.currentTarget.value))}
              value={fileSurveyInstance.sampleToday} />
          }
        </td>
      </tr>
    )
  }

  updateSampleTodayValue(fileSurvey: IFileSurvey, fileSurveyInstance: IFileSurveyInstance | IFileSurveyBranchInstance, prop: FileSurveyInstanceProps, sampleToday: number) {
    const { fileSurveys } = this.state

    const fileSurveyToUpdate = fileSurveys.find((fs) => fs.id === fileSurvey.id)

    if (!fileSurveyToUpdate) {
      return
    }

    const instanceParentToUpdate = fileSurveyToUpdate[prop]

    if (instanceParentToUpdate instanceof Array) {
      const branchSurveyInstance = fileSurveyInstance as IFileSurveyBranchInstance;
      const indexToUpdate = instanceParentToUpdate.findIndex((instance) => instance.branchName === branchSurveyInstance.branchName)

      instanceParentToUpdate[indexToUpdate].sampleToday = sampleToday;
    } else {
      const fileSurveyInstanceToUpdate = instanceParentToUpdate as IFileSurveyInstance;

      fileSurveyInstanceToUpdate.sampleToday = sampleToday;
    }

    this.setState({ fileSurveys })
  }

  submitForm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const { fileSurveys, clientAbbr } = this.state

    this.setState({ submitting: true }, () => {
      SurveyManagementHttp.beforeVerification(clientAbbr, fileSurveys)
        .then((res) => {
          this.props.onSuccess(res)

          location.hash = '/verify'
        })
        .finally(() => this.setState({ submitting: false }))
    })
  }

  refreshQuotas() {
    const { clientAbbr } = this.state;

    this.setState({ loading: true });

    SurveyManagementHttp.refreshQuotas(clientAbbr)
      .then(() => this.getSurveys())
  }

  endMonth() {
    const { clientAbbr } = this.state;

    this.setState({ fileSurveys: [], loading: true })

    SurveyManagementHttp.endMonth(clientAbbr)
      .then(() => this.getSurveys())
  }

  render() {
    const { clientAbbr, showExtraFields, fileSurveys, submitting, loading } = this.state
    const numberFieldStyle = this.getNumberFieldStyle()

    return (
      <Form onSubmit={(e) => this.submitForm(e)} className="blacklight page-bg page-container">
        <GridContainer className="subtleSlideInRight">
          <Card>
            <ContentCardHeader
              sticky
              borderBottom
              header={
                <header>
                  <section className="d-flex justify-content-between">
                    <article>
                      <span>Processing&nbsp;</span>
                      <span className="text-muted">{clientAbbr}&nbsp;</span>
                      {loading &&
                        <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin muted />
                      }
                    </article>
                    <article>
                      <Button color="white" className="mr-2"
                        onClick={() => this.getPrioritizedSurveys("PHONE")}>
                        <FontAwesomeIcon icon="exclamation" fixedWidth verticalAlign="middle" />
                        <span>Prioritize Phone</span>
                      </Button>
                      <Button color="white" className="mr-2"
                        onClick={() => this.getPrioritizedSurveys("ONLINE")}>
                        <FontAwesomeIcon icon="exclamation" fixedWidth verticalAlign="middle" />
                        <span>Prioritize Online</span>
                      </Button>
                      <Button color="white" className="mr-2"
                        onClick={() => this.refreshQuotas()}>
                        <FontAwesomeIcon icon="redo" fixedWidth verticalAlign="middle" />
                        <span>&nbsp;Refresh Quotas</span>
                      </Button>
                      <Button color={showExtraFields ? 'primary' : 'white'}
                        onClick={() => this.toggleShowExtraFields()}>
                        <FontAwesomeIcon icon="columns" fixedWidth verticalAlign="middle" />
                        <span>&nbsp;{showExtraFields ? 'Hide' : 'Show'}</span>
                        <span>&nbsp;Extra Fields</span>
                      </Button>
                    </article>
                  </section>
                </header>
              }
            />
            {!loading &&
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <td></td>
                    <td style={numberFieldStyle}>Available records</td>
                    <td style={numberFieldStyle}>Completed</td>
                    <td style={numberFieldStyle}>Quota</td>
                    {showExtraFields &&
                      <>
                        <td style={numberFieldStyle}>Three month<br />Response rate</td>
                        <td style={numberFieldStyle}>Today's Target</td>
                        <td style={numberFieldStyle}>Need today</td>
                        <td style={numberFieldStyle}>Undialed sample</td>
                        <td style={numberFieldStyle}>Undialed sample<br />age in days</td>
                      </>
                    }
                    <td style={numberFieldStyle}>Sample today</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.fileSurveys.map((fileSurvey) =>
                    <React.Fragment key={fileSurvey.id}>
                      <tr className="bg-dark text-white">
                        <td colSpan={10} className="p-2">
                          <h4 className="d-flex justify-content-start mb-0">
                            <span className="mr-4">{fileSurvey.surveyName}</span>
                          </h4>
                        </td>
                      </tr>
                      {this.renderSurveyTable(fileSurvey)}
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            }

            <CardFooter className="sticky-bottom d-flex justify-content-between bg-white">
              <Button type="button"
                color="white"
                size="lg"
                className="mr-2"
                onClick={() => location.hash = '#/clients'}
                disabled={submitting}>
                <span>Go Back to Clients</span>
              </Button>
              <Button type="submit"
                color="primary"
                size="lg"
                disabled={fileSurveys.length <= 0 || submitting}>
                {submitting &&
                  <FontAwesomeIcon icon="cog" fixedWidth spin verticalAlign="middle" />
                }
                <span>&nbsp;Process</span>
              </Button>
            </CardFooter>
          </Card>
        </GridContainer>
      </Form>
    )
  }
}
